import requestUtils from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-business'

type BusinessApprovalPolicyResponse = paths['/api/business-traveller/businesses/{businessId}/approval-policies']['get']['responses'][200]['content']['application/json']

type BusinessApprovalPolicyResult = paths['/api/business-traveller/businesses/{businessId}/approval-policies']['get']['responses'][200]['content']['application/json']['result']

type PolicyItem = BusinessApprovalPolicyResult[number]

function mapPolicies(policies: BusinessApprovalPolicyResult): Array<App.BusinessTraveller.ApprovalPolicy> {
  return policies.map((policy: PolicyItem) => ({
    id: policy.id,
    name: policy.name,
    scope: policy.scope ?? 'ALWAYS',
    priceBuffer: Number(policy.priceBuffer ?? 0),
    travellers: policy.travellers,
    approvers: policy.approvers,
  }))
}

interface Params {
  businessId: string;
  employeeId: string;
}

async function requestGetPolicy(params: Params) {
  const { businessId, employeeId } = params

  try {
    const policies = await requestUtils.get<BusinessApprovalPolicyResponse>(
      `/api/business-traveller/businesses/${businessId}/approval-policies`,
      { credentials: 'include' },
    )

    const mappedPolicies = mapPolicies(policies.result)

    return mappedPolicies.length ? mappedPolicies.find(policy => policy.travellers.includes(employeeId)) : undefined
  } catch(error) {
    return Promise.reject(error)
  }
}

export default requestGetPolicy
